export const sanitizeContent = (content: string, isComplete = true): string => {
  let result = content
    .replace(/【.*?】/gm, '')
    .replace(/\$formula\$([\s\S]*?)\$formula\$/g, (_, math) => `$${math.trim()}$`)
    .replace(/```math\n([\s\S]*?)```/g, (_, math) => `$$${math.trim()}$$`)
    .replace(/```math(.*?)```/g, '$$$1$$')
    .replace(/\\\[([\s\S]*?)\\\]/g, (_, math) => `$$${math.trim()}$$`)
    .replace(/\\\(/g, '$')
    .replace(/\\\)/g, '$')
    .replace(/\$\$([\s\S]*?)\$\$/g, (_, math) => `$$${math.trim()}$$`);

  if (isComplete) {
    result = result.replace(/```math[\s\S]*$/g, '');

    const dollarPairs = result.match(/\$\$/g);
    if (dollarPairs && dollarPairs.length % 2 !== 0) {
      const lastOpenIndex = result.lastIndexOf('$$');
      result = result.substring(0, lastOpenIndex);
    }
  }

  return result;
};
